import { Flex } from '@chakra-ui/react';
import { memo } from 'react';

import { DEFAULT_CHAT_CONFIG } from './Chat.config';
import { ChatTypeProps } from './Chat.types';
import { ChatInput } from './ChatInput';
import { ChatPanel } from './ChatPanel';

export const Chat = memo(
  ({
    chatDataList,
    isDisabled = false,
    config = DEFAULT_CHAT_CONFIG,
    inputPlaceholder,
    onUpdate = () => {},
    onSubmit = () => {},
  }: ChatTypeProps) => {
    const ChatTestId = 'chat';

    return (
      <Flex flexDir='column' h='full' data-testid={ChatTestId}>
        <ChatPanel
          messages={chatDataList}
          autoScrollToBottom={isDisabled}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
          config={config}
        />
        <ChatInput onSubmit={onSubmit} isDisabled={isDisabled} placeholder={inputPlaceholder} />
      </Flex>
    );
  },
);

Chat.displayName = 'Chat';
